import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\SavePreviewDocumentController::__invoke
* @see app/Http/Controllers/Document/Editor/SavePreviewDocumentController.php
* @route '/api/editor/{type}/{document}/save-preview'
*/
const SavePreviewDocumentController = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SavePreviewDocumentController.url(args, options),
    method: 'post',
})

SavePreviewDocumentController.definition = {
    methods: ["post"],
    url: '/api/editor/{type}/{document}/save-preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\Editor\SavePreviewDocumentController::__invoke
* @see app/Http/Controllers/Document/Editor/SavePreviewDocumentController.php
* @route '/api/editor/{type}/{document}/save-preview'
*/
SavePreviewDocumentController.url = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
    }

    return SavePreviewDocumentController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\SavePreviewDocumentController::__invoke
* @see app/Http/Controllers/Document/Editor/SavePreviewDocumentController.php
* @route '/api/editor/{type}/{document}/save-preview'
*/
SavePreviewDocumentController.post = (args: { type: string | number, document: string | number } | [type: string | number, document: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SavePreviewDocumentController.url(args, options),
    method: 'post',
})

export default SavePreviewDocumentController